export default "__VITE_ASSET__BWTwr33q__"